import styled from 'styled-components';

export const Wrapper = styled.div`
  > div:not(:first-child) {
    margin-top: 2rem;
  }
`;
